import _extends from "/opt/build/repo/node_modules/.pnpm/next@15.5.6_@babel+core@7.28.5_@opentelemetry+api@1.9.0_@playwright+test@1.56.1_babel-p_096ab9bbeffdff0fc88514782f3793fe/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import * as React from 'react';
import { useRunner } from 'react-runner';
// The docs https://github.com/nihgwu/react-runner
export default function ReactRunner(props) {
  var code = props.code,
    scopeProp = props.scope,
    onError = props.onError;
  var scope = scopeProp;
  if (false) {
    // TODO: uncomment once we enable eslint-plugin-react-compiler // eslint-disable-next-line react-compiler/react-compiler -- valid reason to disable the rules of hooks
    // eslint-disable-next-line react-hooks/rules-of-hooks -- process.env never changes
    scope = React.useMemo(function () {
      var handler = {
        get: function get() {
          throw new Error(['A demo tries to access process.x in ReactRunner. This is not supported.', 'If you do not need to show the source, you can set "hideToolbar": true to solve the issue.'].join('\n'));
        }
      };
      return _extends({}, scopeProp, {
        process: new Proxy(scopeProp.process, handler)
      });
    }, [scopeProp]);
  }
  var _useRunner = useRunner({
      code: code,
      scope: scope
    }),
    element = _useRunner.element,
    error = _useRunner.error;
  React.useEffect(function () {
    onError(error);
  }, [error, onError]);
  return element;
}